import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import UserListTable from "./UserListTable";
import UserListModal from "./UserListModal";
import DeleteUserModal from "./DeleteUserModal";
import { useDispatch, useSelector } from "react-redux";
import { setUserModalType, toggleUserModal } from "../../../slices/modals/reducer";
import { createSelector } from "reselect";
import checkPermission from "../../../Components/Hooks/PermissionHook";
import { Navigate } from "react-router-dom";
import { setUserPermission } from "../../../slices/auth/settings/reducer";
import { setBreadcrumb } from "../../../slices/auth/menu/reducer";
import ActivateUserModal from "./ActivateUserModal";

/**
 * Functional component for displaying user list.
 * @component
 */
export default function UserList() {
  const dispatch = useDispatch();

  const selectCompanyState = createSelector(state => state.MenuData, state => state.client);
  const company = useSelector(selectCompanyState);

  function openModal() {
    dispatch(setUserModalType("add"));
    dispatch(setUserPermission([]));
    dispatch(toggleUserModal());
  }

  useEffect(() => {
    dispatch(setBreadcrumb({ pageTitle: 'Settings', title: [{ name: 'User List', src: window.location.href }] }));
  }, []);

  // if (checkPermission("companies", company._id, "userView")) {
    return (
      <div className="table-responsive table-card mt-3 mb-1">
        <Container fluid>
          <Row>
            <Col className="col-sm-6">
              <div>

              </div>
            </Col>
            <Col className="col-sm-6">
              <div className="d-flex justify-content-end">
                {checkPermission("companies", company._id, "userCreate") ?
                  <Button color="info" className="add-btn" id="create-btn" onClick={openModal}>
                    <i className="ri-add-line align-bottom"></i> Invite User
                  </Button>
                  : null}
              </div>
            </Col>
          </Row>
          <UserListTable />
          <DeleteUserModal />
          <ActivateUserModal />
        </Container>
        <UserListModal />
      </div>
    )
  // } else {
  //   return (
  //     <Navigate to="/settings/personal-details" />
  //   )
  // }

};